import { Button } from '@/components/common/Button';
import {
    Sheet,
    SheetHeader,
    SheetContent,
    SheetTrigger,
    SheetTitle,
    SheetDescription,
    SheetClose
} from '@/components/common/Sheet';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import React from 'react';
import Menu from './_components/Menu';
import ToggleBarMenuIcon from '@/components/icon/ToggleBarMenuIcon';
import { observer } from 'mobx-react-lite';
import { LogoCMS } from '@/components/general/logo/Logo';

interface WrapperSheetCloseProps {
    useSheetClose?: boolean
}

export const WrapperSheetClose = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & WrapperSheetCloseProps
>(({ children, useSheetClose, ...props }, ref) => (
    <div ref={ref} {...props}>
        {
            !useSheetClose ?
                (
                    <>{children}</>
                ) :
                (
                    <SheetClose asChild>{children}</SheetClose>
                )
        }
    </div>
));
WrapperSheetClose.displayName = 'WrapperSheetClose';

export default observer(function SheetMenu() {
    return (
        <Sheet>
            <SheetTrigger className='lg:hidden' asChild>
                <Button
                    variant='ghost'
                    size='icon'
                    className='rounded-md hover:bg-transparent'
                >
                    <ToggleBarMenuIcon />
                </Button>
            </SheetTrigger>
            <SheetContent
                className='w-72 px-0 h-full flex flex-col bg-black-5'
                side='left'
            >
                <SheetHeader>
                    <SheetTitle>
                        <VisuallyHidden.Root>
                            {/* Sheet Menu */}
                        </VisuallyHidden.Root>
                    </SheetTitle>
                    <SheetDescription>
                        <VisuallyHidden.Root>
                            {/* Description goes here */}
                        </VisuallyHidden.Root>
                    </SheetDescription>
                    <WrapperSheetClose useSheetClose>
                        <Button
                            className='flex justify-center items-center'
                            variant='link'
                            asChild
                        >
                            <div className='flex items-center justify-center'>
                                <LogoCMS linkClassName='h-12 w-auto' />
                            </div>

                        </Button>
                    </WrapperSheetClose>
                </SheetHeader>
                <Menu isOpen={true} isMenuSheet={true} useSheetClose />
            </SheetContent>
        </Sheet>
    );
});
